// // import React, { useEffect } from "react";
// // import { connect } from "react-redux";
// // import Login from "./pages/login";
// // import Secure from "./pages/secure";
// // import "../src/assets/css/material-dashboard.css";
// // // import "../src/assets/css/material-dashboard.css";
// // // import "../src/assets1/css/material-dashboard.css";
// // // // import "../src/assets/css/"

// // import "bootstrap/dist/js/bootstrap.js";
// // // import "https://kit.fontawesome.com/42d5adcbca.js";
// // import "react-toastify/dist/ReactToastify.css";
// // import { withRouter } from "react-router-dom";

// // import { logout } from "./redux/actions/auth";
// // import { toast } from "react-toastify";
// // import axios from "axios";
// // import "bootstrap/dist/js/bootstrap.js";
// // import "material-icons/iconfont/material-icons.css";

// // export var common_axios = axios.create({
// //   //  baseURL: "http://192.168.167.66:5001/",
// //   baseURL: "http://10.0.233.148:5001/",


// // });

// // const App = (props) => {
// //   const Routes = props.auth ? Secure : Login;
// //   const { history } = props;

// //   // useEffect(() => {
// //   //   history.listen((newLocation, action) => {
// //   //     if (action === "PUSH") {
// //   //       if (
// //   //         newLocation.pathname !== this.currentPathname ||
// //   //         newLocation.search !== this.currentSearch
// //   //       ) {
// //   //         // Save new location
// //   //         this.currentPathname = newLocation.pathname;
// //   //         this.currentSearch = newLocation.search;

// //   //         // Clone location object and push it to history
// //   //         history.push({
// //   //           pathname: newLocation.pathname,
// //   //           search: newLocation.search,
// //   //         });
// //   //       }
// //   //     } else {
// //   //       // Send user back if they try to navigate back
// //   //       history.go(1);
// //   //     }
// //   //   });
// //   // }, []);

// //   console.log(history.action);
// //   axios.interceptors.request.use(
// //     (req) => {
// //       console.log({ req });
// //       // Add configurations here FOR AXIOS
// //       // const token1 = localStorage.getItem("token");
// //       // // axios.defaults.headers.common[""];
// //       // req.headers["Authorization"] = `Bearer ${token1}`;
// //       // req.headers["source"] = `web`;
// //       // console.log("Get", token1);
// //       // console.log();
// //       return req;
// //     },
// //     (err) => {
// //       console.log(err);
// //       return Promise.reject(err);
// //     }
// //   );

// //   console.log(props.location.pathname);

// //   // TOKEN AFTER REFRESH
// //   const token1 = localStorage.getItem("token");
// //   const uid = localStorage.getItem("UserId");
// //   common_axios.defaults.headers.common["Authorization"] = "Bearer " + token1;
// //   common_axios.defaults.headers.common["source"] = "web";
// //   common_axios.defaults.headers.common["UserId"] = uid;

// //   axios.interceptors.response.use(
// //     (res) => {
// //       console.log({ res });
// //       // Add configurations here FOR AXIOS RESPONSE
// //       if (
// //         res.request.responseURL == "http://10.0.233.148:5001/auth/v1/login" ||
// //         res.request.responseURL ==
// //           "http://10.0.233.148:5001/auth/v1/pin/verify"
// //       ) {
// //         if (res?.data?.statusDescription?.statusCode == 200) {
// //           // TOKEN BEFORE REFRESH OTHERWISE EXPIRED TOKEN
// //           localStorage.setItem(
// //             "token",
// //             res?.data?.userDetail?.userTokenDetails?.jwtToken
// //           );
// //           localStorage.setItem("UserId", res.data.userDetail.uid);
// //           const token1 = localStorage.getItem("token");
// //           const uid = localStorage.getItem("UserId");

// //           common_axios.defaults.headers.common["Authorization"] =
// //             "Bearer " + token1;
// //           common_axios.defaults.headers.common["UserId"] = uid;

// //           common_axios.defaults.headers.common["source"] = "web";
// //         }
// //       }
// //       // console.log("code", res.data.statusDescription.statusCode);
// //       if (
// //         res?.data?.statusDescription?.statusCode == 102 ||
// //         res?.data?.statusDescription?.statusCode == 303
// //       ) {
// //         localStorage.clear();
// //         setTimeout(() => {
// //           history.replace("/");
// //         }, 500);

// //         setTimeout(() => {
// //           toast.success(res.data.statusDescription.description, {
// //             theme: "colored",
// //           });
// //         }, 200);

// //         props.logout();
// //         // history.replace("/");
// //         // window.location.pathname = "/";
// //       }
// //       return res;
// //     },
// //     (err) => {
// //       console.log(err);
// //       return Promise.reject(err);
// //     }
// //   );

// //   common_axios.interceptors.response.use(
// //     (res) => {
// //       console.log({ res });
// //       // Add configurations here FOR AXIOS RESPONSE
// //       if (
// //         res?.data?.statusDescription?.statusCode == 102 ||
// //         res?.data?.statusDescription?.statusCode == 303
// //       ) {
// //         localStorage.clear();
// //         history.replace("/");

// //         setTimeout(() => {
// //           toast.success(res.data.statusDescription.description, {
// //             theme: "colored",
// //           });
// //         }, 200);

// //         props.logout();
// //       }
// //       return res;
// //     },
// //     (err) => {
// //       console.log(err);
// //       return Promise.reject(err);
// //     }
// //   );

// //   // console.log(props.location.pathname);
// //   const checkToken = async () => {
// //     if (localStorage.getItem("UserId")) {
// //       const res = await common_axios.get(
// //         `${process.env.REACT_APP_COMMON_API}/auth/v1/check/token`
// //       );
// //       if (
// //         res.data.statusDescription.statusCode == 200 ||
// //         props.location.pathname == "/AccountVerification" ||
// //         props.location.pathname == "/SignUp" ||
// //         props.location.pathname == "/forgotpassword" ||
// //         props.location.pathname == "/forgot/updatepassword" ||
// //         props.location.pathname == "VerifyOtp" ||
// //         props.location.pathname == "/users" ||
// //         props.location.pathname == "/contactus"
// //       ) {
// //       } else {
// //         await props.logout();
// //         history.replace("/");
// //       }
// //     }
// //   };
// //   if (history.action == "PUSH") {
// //     checkToken();
// //     document.body.className = "g-sidenav-show bg-gray-200";
// //   } else if (history.action == "POP") {
// //     checkToken();
// //     document.body.className = "g-sidenav-show bg-gray-200";
// //   }
// //   return <Routes />;
// // };
// // const mapStateToProps = (state) => (
// //   console.log(state),
// //   {
// //     auth: state.authReducer.auth,
// //   }
// // );
// // // const mapDispatchToProps = {};
// // const mapDispatchToProps = (dispatch) => ({
// //   logout: () => dispatch(logout()),
// // });
// // export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))

// import React, { useEffect } from "react";
// import { connect } from "react-redux";
// import Login from "./pages/login";
// import Secure from "./pages/secure";
// import "../src/assets/css/material-dashboard.css";
// // import "../src/assets/css/material-dashboard.css";
// // import "../src/assets1/css/material-dashboard.css";
// // // import "../src/assets/css/"

// import "bootstrap/dist/js/bootstrap.js";
// // import "https://kit.fontawesome.com/42d5adcbca.js";
// import "react-toastify/dist/ReactToastify.css";
// import { withRouter } from "react-router-dom";
// import Swal from "sweetalert2";

// import { logout, logoutt } from "./redux/actions/auth";
// import { toast } from "react-toastify";
// import axios from "axios";
// import "bootstrap/dist/js/bootstrap.js";
// import "material-icons/iconfont/material-icons.css";

// export var common_axios = axios.create({
//   // baseURL: "http://192.168.167.66:5001/",
//   baseURL: `${process.env.REACT_APP_COMMON_API}/`,
// });
// const customId1 = "custom-id-yess";

// const App = (props) => {


  
//   const Routes = props.auth ? Secure : Login;
//   const { history } = props;

//   // useEffect(() => {
//   //   history.listen((newLocation, action) => {
//   //     if (action === "PUSH") {
//   //       if (
//   //         newLocation.pathname !== this.currentPathname ||
//   //         newLocation.search !== this.currentSearch
//   //       ) {
//   //         // Save new location
//   //         this.currentPathname = newLocation.pathname;
//   //         this.currentSearch = newLocation.search;

//   //         // Clone location object and push it to history
//   //         history.push({
//   //           pathname: newLocation.pathname,
//   //           search: newLocation.search,
//   //         });
//   //       }
//   //     } else {
//   //       // Send user back if they try to navigate back
//   //       history.go(1);
//   //     }
//   //   });
//   // }, []);

//   // console.log(history.action);
//   axios.interceptors.request.use(
//     (req) => {
//       // console.log({ req });
//       // Add configurations here FOR AXIOS
//       // const token1 = localStorage.getItem("token");
//       // // axios.defaults.headers.common[""];
//       // req.headers["Authorization"] = `Bearer ${token1}`;
//       // req.headers["source"] = `web`;
//       // console.log("Get", token1);
//       // console.log();
//       return req;
//     },
//     (err) => {
//       // console.log(err);
//       return Promise.reject(err);
//     }
//   );

//   // console.log(props.location.pathname);

//   // TOKEN AFTER REFRESH
//   const token1 = localStorage.getItem("token");
//   const uid = localStorage.getItem("UserId");
//   common_axios.defaults.headers.common["Authorization"] = "Bearer " + token1;
//   common_axios.defaults.headers.common["source"] = "web";
//   common_axios.defaults.headers.common["UserId"] = uid;

//   axios.interceptors.response.use(
//     async (res) => {
//       // console.log({ res });
//       // Add configurations here FOR AXIOS RESPONSE
//       if (
//         res.request.responseURL ==
//           `${process.env.REACT_APP_COMMON_API}/auth/v1/login` ||
//         res.request.responseURL ==
//           `${process.env.REACT_APP_COMMON_API}/auth/v1/pin/verify`
//       ) {
//         if (res?.data?.statusDescription?.statusCode == 200) {
//           // TOKEN BEFORE REFRESH OTHERWISE EXPIRED TOKEN
//           localStorage.setItem(
//             "token",
//             res?.data?.userDetail?.userTokenDetails?.jwtToken
//           );
//           localStorage.setItem("UserId", res.data.userDetail.uid);
//           // localStorage.setItem("usernamedisplayed", res.data.userDetail.username);

//           const token1 = localStorage.getItem("token");
//           const uid = localStorage.getItem("UserId");

//           common_axios.defaults.headers.common["Authorization"] =
//             "Bearer " + token1;
//           common_axios.defaults.headers.common["UserId"] = uid;

//           common_axios.defaults.headers.common["source"] = "web";
//           // common_axios.defaults.headers.common["username"] =username;
//         }
//       }
//       // console.log("code", res.data.statusDescription.statusCode);
//       if (
//         res?.data?.statusDescription?.statusCode == 102 ||
//         res?.data?.statusDescription?.statusCode == 303 ||
//         res?.data?.statusDescription?.statusCode == 404

//       )
      
      
//       // {
//       //   localStorage.clear();
//       //   setTimeout(() => {
//       //     history.replace("/");
//       //   }, 500);

//       //   setTimeout(() => {
//       //     toast.success(res.data.statusDescription.description, {
//       //       theme: "colored",
//       //     });
//       //   }, 200);

//       //   props.logout();
//       //   // history.replace("/");
//       //   // window.location.pathname = "/";
//       // }


//       {
//         await props.logout1();
//         history.replace("/");

//         setTimeout(() => {
//           // toast.success(res.data.statusDescription.description, {
//           //   theme: "colored",
//           //   toastId: customId1,
//           // });
//           Swal.fire({
//             icon: "error",
//              title: "Oops...",
//             text: res.data.statusDescription.statusMessage,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }, 200);
//       }
//       return res;
      
//     },
//     (err) => {
//       // console.log(err);
//       return Promise.reject(err);
//     }
//   );


//   // common_axios.interceptors.response.use(
//   //   (res) => {
//   //     console.log({ res });
//   //     // Add configurations here FOR AXIOS RESPONSE
//   //     if (
//   //       res?.data?.statusDescription?.statusCode == 102 ||
//   //       res?.data?.statusDescription?.statusCode == 303 ||
//   //       res?.data?.statusDescription?.statusCode == 404

//   //     ) {
//   //       localStorage.clear();
//   //       history.replace("/");

//   //       setTimeout(() => {
//   //         toast.success(res.data.statusDescription.description, {
//   //           theme: "colored",
//   //         });
//   //       }, 200);

//   //       props.logout();
//   //     }
//   //     return res;
//   //   },
//   //   (err) => {
//   //     console.log(err);
//   //     return Promise.reject(err);
//   //   }
//   // );

//   common_axios.interceptors.response.use(
//     async (res) => {
//       // console.log({ res });
//       // Add configurations here FOR AXIOS RESPONSE
//       if (
//         res?.data?.statusDescription?.statusCode == 102 ||
//         res?.data?.statusDescription?.statusCode == 303 ||
//         res?.data?.statusDescription?.statusCode == 404
//       ) {
//         await props.logout1();
//         history.replace("/");

//         setTimeout(() => {
//           // toast.success(res.data.statusDescription.description, {
//           //   theme: "colored",
//           //   toastId: customId1,
//           // });
//           Swal.fire({
//             icon: "error",
//              title: "Oops...",
//             text: res.data.statusDescription.statusMessage,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }, 200);
//       }
//       return res;
//     },
//     (err) => {
//       // console.log(err);
//       return Promise.reject(err);
//     }
//   );


//   // console.log(props.location.pathname);
//   // const checkToken = async () => {
//   //   if (localStorage.getItem("UserId")) {
//   //     const res = await common_axios.get(
//   //       `${process.env.REACT_APP_COMMON_API}/auth/v1/check/token`
//   //     );
//   //     if (
//   //       res.data.statusDescription.statusCode == 200 ||
//   //       props.location.pathname == "/AccountVerification" ||
//   //       props.location.pathname == "/SignUp" ||
//   //       props.location.pathname == "/forgotpassword" ||
//   //       props.location.pathname == "/forgot/updatepassword" ||
//   //       props.location.pathname == "VerifyOtp" ||
//   //       props.location.pathname == "/users" ||
//   //       props.location.pathname == "/contactus"
//   //     ) {
//   //     } else {
//   //       await props.logout();
//   //       history.replace("/");
//   //     }
//   //   }
//   // };

//   const checkToken = async () => {
//     if (localStorage.getItem("token")) {
//       const res = await common_axios.get(
//         `${process.env.REACT_APP_COMMON_API}/auth/v1/check/token`
//       );
//       if (res.data.statusDescription.statusCode != 200) {
//         await props.logout1();
//         history.replace("/");
//         setTimeout(() => {
//           // toast.success(res.data.statusDescription.description, {
//           //   theme: "colored",
//           //   toastId: customId1,
//           // });
//           Swal.fire({
//             icon: "error",
//            title: "Oops...",
//             text: res.data.statusDescription.statusMessage,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }, 200);
//       }
//     }
//   };
//   if (history.action == "PUSH") {
//     checkToken();
//     document.body.className = "g-sidenav-show bg-gray-200";
//   } else if (history.action == "POP") {
//     checkToken();
//     document.body.className = "g-sidenav-show bg-gray-200";
//   }



//   // if (history.action == "PUSH") {
//   //   checkToken();
//   //   document.body.className = "g-sidenav-show bg-gray-200";
//   // } else if (history.action == "POP") {
//   //   checkToken();
//   //   document.body.className = "g-sidenav-show bg-gray-200";
//   // }

//   return <Routes />;
// };

// const mapStateToProps = (state) => (
//   // console.log(state),
//   {
//     auth: state.authReducer.auth,
//   }
// );

// // const mapDispatchToProps = {};

// const mapDispatchToProps = (dispatch) => ({
//   logout: () => dispatch(logout()),
//   logout1: () =>  dispatch(logoutt())
// });

// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));










// import React, { useEffect } from "react";
// import { connect } from "react-redux";
// import Login from "./pages/login";
// import Secure from "./pages/secure";
// import "../src/assets/css/material-dashboard.css";
// // import "../src/assets/css/material-dashboard.css";
// // import "../src/assets1/css/material-dashboard.css";
// // // import "../src/assets/css/"

// import "bootstrap/dist/js/bootstrap.js";
// // import "https://kit.fontawesome.com/42d5adcbca.js";
// import "react-toastify/dist/ReactToastify.css";
// import { withRouter } from "react-router-dom";

// import { logout } from "./redux/actions/auth";
// import { toast } from "react-toastify";
// import axios from "axios";
// import "bootstrap/dist/js/bootstrap.js";
// import "material-icons/iconfont/material-icons.css";

// export var common_axios = axios.create({
//   //  baseURL: "http://192.168.167.66:5001/",
//   baseURL: "http://10.0.233.148:5001/",

// });

// const App = (props) => {
//   const Routes = props.auth ? Secure : Login;
//   const { history } = props;

//   // useEffect(() => {
//   //   history.listen((newLocation, action) => {
//   //     if (action === "PUSH") {
//   //       if (
//   //         newLocation.pathname !== this.currentPathname ||
//   //         newLocation.search !== this.currentSearch
//   //       ) {
//   //         // Save new location
//   //         this.currentPathname = newLocation.pathname;
//   //         this.currentSearch = newLocation.search;

//   //         // Clone location object and push it to history
//   //         history.push({
//   //           pathname: newLocation.pathname,
//   //           search: newLocation.search,
//   //         });
//   //       }
//   //     } else {
//   //       // Send user back if they try to navigate back
//   //       history.go(1);
//   //     }
//   //   });
//   // }, []);

//   console.log(history.action);
//   axios.interceptors.request.use(
//     (req) => {
//       console.log({ req });
//       // Add configurations here FOR AXIOS
//       // const token1 = localStorage.getItem("token");
//       // // axios.defaults.headers.common[""];
//       // req.headers["Authorization"] = `Bearer ${token1}`;
//       // req.headers["source"] = `web`;
//       // console.log("Get", token1);
//       // console.log();
//       return req;
//     },
//     (err) => {
//       console.log(err);
//       return Promise.reject(err);
//     }
//   );

//   console.log(props.location.pathname);

//   // TOKEN AFTER REFRESH
//   const token1 = localStorage.getItem("token");
//   const uid = localStorage.getItem("UserId");
//   common_axios.defaults.headers.common["Authorization"] = "Bearer " + token1;
//   common_axios.defaults.headers.common["source"] = "web";
//   common_axios.defaults.headers.common["UserId"] = uid;

//   axios.interceptors.response.use(
//     (res) => {
//       console.log({ res });
//       // Add configurations here FOR AXIOS RESPONSE
//       if (
//         res.request.responseURL == "http://10.0.233.148:5001/auth/v1/login" ||
//         res.request.responseURL ==
//           "http://10.0.233.148:5001/auth/v1/pin/verify"
//       ) {
//         if (res?.data?.statusDescription?.statusCode == 200) {
//           // TOKEN BEFORE REFRESH OTHERWISE EXPIRED TOKEN
//           localStorage.setItem(
//             "token",
//             res?.data?.userDetail?.userTokenDetails?.jwtToken
//           );
//           localStorage.setItem("UserId", res.data.userDetail.uid);
//           const token1 = localStorage.getItem("token");
//           const uid = localStorage.getItem("UserId");

//           common_axios.defaults.headers.common["Authorization"] =
//             "Bearer " + token1;
//           common_axios.defaults.headers.common["UserId"] = uid;

//           common_axios.defaults.headers.common["source"] = "web";
//         }
//       }
//       // console.log("code", res.data.statusDescription.statusCode);
//       if (
//         res?.data?.statusDescription?.statusCode == 102 ||
//         res?.data?.statusDescription?.statusCode == 303
//       ) {
//         localStorage.clear();
//         setTimeout(() => {
//           history.replace("/");
//         }, 500);

//         setTimeout(() => {
//           toast.success(res.data.statusDescription.description, {
//             theme: "colored",
//           });
//         }, 200);

//         props.logout();
//         // history.replace("/");
//         // window.location.pathname = "/";
//       }
//       return res;
//     },
//     (err) => {
//       console.log(err);
//       return Promise.reject(err);
//     }
//   );

//   common_axios.interceptors.response.use(
//     (res) => {
//       console.log({ res });
//       // Add configurations here FOR AXIOS RESPONSE
//       if (
//         res?.data?.statusDescription?.statusCode == 102 ||
//         res?.data?.statusDescription?.statusCode == 303
//       ) {
//         localStorage.clear();
//         history.replace("/");

//         setTimeout(() => {
//           toast.success(res.data.statusDescription.description, {
//             theme: "colored",
//           });
//         }, 200);

//         props.logout();
//       }
//       return res;
//     },
//     (err) => {
//       console.log(err);
//       return Promise.reject(err);
//     }
//   );

//   // console.log(props.location.pathname);
//   const checkToken = async () => {
//     if (localStorage.getItem("UserId")) {
//       const res = await common_axios.get(
//         `${process.env.REACT_APP_COMMON_API}/auth/v1/check/token`
//       );
//       if (
//         res.data.statusDescription.statusCode == 200 ||
//         props.location.pathname == "/AccountVerification" ||
//         props.location.pathname == "/SignUp" ||
//         props.location.pathname == "/forgotpassword" ||
//         props.location.pathname == "/forgot/updatepassword" ||
//         props.location.pathname == "VerifyOtp" ||
//         props.location.pathname == "/users" ||
//         props.location.pathname == "/contactus"
//       ) {
//       } else {
//         await props.logout();
//         history.replace("/");
//       }
//     }
//   };
//   if (history.action == "PUSH") {
//     checkToken();
//     document.body.className = "g-sidenav-show bg-gray-200";
//   } else if (history.action == "POP") {
//     checkToken();
//     document.body.className = "g-sidenav-show bg-gray-200";
//   }
//   return <Routes />;
// };
// const mapStateToProps = (state) => (
//   console.log(state),
//   {
//     auth: state.authReducer.auth,
//   }
// );
// // const mapDispatchToProps = {};
// const mapDispatchToProps = (dispatch) => ({
//   logout: () => dispatch(logout()),
// });
// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))

import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import Login from "./pages/login";
import Secure from "./pages/secure";
import "../src/assets/css/material-dashboard.css";
// import "../src/assets/css/material-dashboard.css";
// import "../src/assets1/css/material-dashboard.css";
// // import "../src/assets/css/"

import "bootstrap/dist/js/bootstrap.js";
// import "https://kit.fontawesome.com/42d5adcbca.js";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";

import { logout, logoutt } from "./redux/actions/auth";
import { toast } from "react-toastify";
import axios from "axios";
import "bootstrap/dist/js/bootstrap.js";
import "material-icons/iconfont/material-icons.css";
import { useSelector } from "react-redux";
import { TwofactAuth } from "./redux/features/pageSlices";

export var common_axios = axios.create({
  // baseURL: "http://192.168.167.66:5001/",
  baseURL: `${process.env.REACT_APP_COMMON_API}/`,
});
const customId1 = "custom-id-yess";

const App = (props) => {
  // const is2factAuth = localStorage.getItem("is2FactorAuth");
  const is2factAuth = useSelector((state) => state.pageReducer.TwofactAuth);
  const Routes =
    props.auth && (is2factAuth == 0 || is2factAuth == null) ? Secure : Login;
  const { history } = props;

  // useEffect(() => {
  //   history.listen((newLocation, action) => {
  //     if (action === "PUSH") {
  //       if (
  //         newLocation.pathname !== this.currentPathname ||
  //         newLocation.search !== this.currentSearch
  //       ) {
  //         // Save new location
  //         this.currentPathname = newLocation.pathname;
  //         this.currentSearch = newLocation.search;

  //         // Clone location object and push it to history
  //         history.push({
  //           pathname: newLocation.pathname,
  //           search: newLocation.search,
  //         });
  //       }
  //     } else {
  //       // Send user back if they try to navigate back
  //       history.go(1);
  //     }
  //   });
  // }, []);

  // console.log(history.action);
  axios.interceptors.request.use(
    (req) => {
      // console.log({ req });
      // Add configurations here FOR AXIOS
      // const token1 = localStorage.getItem("token");
      // // axios.defaults.headers.common[""];
      // req.headers["Authorization"] = `Bearer ${token1}`;
      // req.headers["source"] = `web`;
      // console.log("Get", token1);
      // console.log();
      return req;
    },
    (err) => {
      // console.log(err);
      return Promise.reject(err);
    }
  );

  // console.log(props.location.pathname);

  // TOKEN AFTER REFRESH
  const token1 = localStorage.getItem("token");
  const uid = localStorage.getItem("UserId");
  common_axios.defaults.headers.common["Authorization"] = "Bearer " + token1;
  common_axios.defaults.headers.common["source"] = "web";
  common_axios.defaults.headers.common["UserId"] = uid;

  axios.interceptors.response.use(
    async (res) => {
      // console.log({ res });
      // Add configurations here FOR AXIOS RESPONSE
      if (
        res.request.responseURL ==
          `${process.env.REACT_APP_COMMON_API}/auth/v1/login` ||
        res.request.responseURL ==
          `${process.env.REACT_APP_COMMON_API}/auth/v1/pin/verify`
      ) {
        if (res?.data?.statusDescription?.statusCode == 200) {
          // TOKEN BEFORE REFRESH OTHERWISE EXPIRED TOKEN
          localStorage.setItem(
            "token",
            res?.data?.userDetail?.userTokenDetails?.jwtToken
          );
          localStorage.setItem("UserId", res.data.userDetail.uid);
          // localStorage.setItem("usernamedisplayed", res.data.userDetail.username);

          const token1 = localStorage.getItem("token");
          const uid = localStorage.getItem("UserId");

          common_axios.defaults.headers.common["Authorization"] =
            "Bearer " + token1;
          common_axios.defaults.headers.common["UserId"] = uid;

          common_axios.defaults.headers.common["source"] = "web";
          // common_axios.defaults.headers.common["username"] =username;
        }
      }
      // console.log("code", res.data.statusDescription.statusCode);
      if (
        res?.data?.statusDescription?.statusCode == 102 ||
        res?.data?.statusDescription?.statusCode == 303 ||
        res?.data?.statusDescription?.statusCode == 404
      ) {
        // {
        //   localStorage.clear();
        //   setTimeout(() => {
        //     history.replace("/");
        //   }, 500);

        //   setTimeout(() => {
        //     toast.success(res.data.statusDescription.description, {
        //       theme: "colored",
        //     });
        //   }, 200);

        //   props.logout();
        //   // history.replace("/");
        //   // window.location.pathname = "/";
        // }

        await props.logout1();
        history.replace("/");

        setTimeout(() => {
          // toast.success(res.data.statusDescription.description, {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 200);
      }
      return res;
    },
    (err) => {
      // console.log(err);
      return Promise.reject(err);
    }
  );

  // common_axios.interceptors.response.use(
  //   (res) => {
  //     console.log({ res });
  //     // Add configurations here FOR AXIOS RESPONSE
  //     if (
  //       res?.data?.statusDescription?.statusCode == 102 ||
  //       res?.data?.statusDescription?.statusCode == 303 ||
  //       res?.data?.statusDescription?.statusCode == 404

  //     ) {
  //       localStorage.clear();
  //       history.replace("/");

  //       setTimeout(() => {
  //         toast.success(res.data.statusDescription.description, {
  //           theme: "colored",
  //         });
  //       }, 200);

  //       props.logout();
  //     }
  //     return res;
  //   },
  //   (err) => {
  //     console.log(err);
  //     return Promise.reject(err);
  //   }
  // );
const dispatch = useDispatch()
  common_axios.interceptors.response.use(
    async (res) => {
      // console.log({ res });
      // Add configurations here FOR AXIOS RESPONSE
      if (
        res?.data?.statusDescription?.statusCode == 102 ||
        res?.data?.statusDescription?.statusCode == 303 ||
        res?.data?.statusDescription?.statusCode == 404
      ) {
        await props.logout1();
        history.replace("/");

        setTimeout(() => {
          // toast.success(res.data.statusDescription.description, {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 200);
      }
      return res;
    },
    (err) => {
      // console.log(err);
      return Promise.reject(err);
    }
  );

  // console.log(props.location.pathname);
  // const checkToken = async () => {
  //   if (localStorage.getItem("UserId")) {
  //     const res = await common_axios.get(
  //       `${process.env.REACT_APP_COMMON_API}/auth/v1/check/token`
  //     );
  //     if (
  //       res.data.statusDescription.statusCode == 200 ||
  //       props.location.pathname == "/AccountVerification" ||
  //       props.location.pathname == "/SignUp" ||
  //       props.location.pathname == "/forgotpassword" ||
  //       props.location.pathname == "/forgot/updatepassword" ||
  //       props.location.pathname == "VerifyOtp" ||
  //       props.location.pathname == "/users" ||
  //       props.location.pathname == "/contactus"
  //     ) {
  //     } else {
  //       await props.logout();
  //       history.replace("/");
  //     }
  //   }
  // };

  const checkToken = async () => {
    if (localStorage.getItem("token")) {
      const res = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API}/auth/v1/check/token`
      );
      if (res.data.statusDescription.statusCode != 200) {
        await props.logout1();
        dispatch(TwofactAuth("0"));
        history.replace("/");
        setTimeout(() => {
          // toast.success(res.data.statusDescription.description, {
          //   theme: "colored",
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 200);
      }
    }
  };
  if (history.action == "PUSH") {
    checkToken();
    document.body.className = "g-sidenav-show bg-gray-200 p-0";
  } else if (history.action == "POP") {
    checkToken();
    document.body.className = "g-sidenav-show bg-gray-200 p-0";
  }

  // if (history.action == "PUSH") {
  //   checkToken();
  //   document.body.className = "g-sidenav-show bg-gray-200";
  // } else if (history.action == "POP") {
  //   checkToken();
  //   document.body.className = "g-sidenav-show bg-gray-200";
  // }

  return <Routes />;
};

const mapStateToProps = (state) =>
  // console.log(state),
  ({
    auth: state.authReducer.auth,
  });

// const mapDispatchToProps = {};

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
  logout1: () => dispatch(logoutt()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
